import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { meseInItaliano, èOggi, isDateTimeInFutureOrNow } from '../../utils/utilityfunction';
import { eliminaEvento } from '../../actions/agenda';



const EventoElement = ({ auth: { user }, titoloEvento, descrizioneEvento, dataEvento, orarioEvento, roomName, roomKey, idEvento, eliminaEvento, meetingId, archivio, isActive}) => {


    return (
      <div className="call-item">
                <div className="call-item-wrap">
                  <div className="call-item-time">
                    {isActive ?
                    <>
                    <div class="day">OGGI</div>
                    <div class="hour">ore: <strong class="orario">{orarioEvento}</strong></div>
                    </>
                    :
                    <>
                    <div class="day">{ èOggi(new Date(dataEvento)) ? "OGGI" : new Date(dataEvento).getDate()}</div>
                    <div class="month">{ èOggi(new Date(dataEvento)) ? "" : meseInItaliano(new Date(dataEvento))}</div>
                    <div class="hour">ore: <strong class="orario">{orarioEvento}</strong></div>
                    </>
                    }
                  </div>
                  <div>
                    <h2 className="heading-2">{titoloEvento}</h2>
                    <h3 className="heading">{descrizioneEvento}</h3>
                  </div>
                </div>
                {user && user.ruolo == 'admin' && isDateTimeInFutureOrNow(dataEvento, orarioEvento)?
                <>
                <div className='modifica_evento'>
                  <a href={`modifica-evento/${idEvento}`} className="button w-button"><img src="/assets/media/pen-solid.svg" alt="Icona modifica" /></a>
                </div>
                <div className='elimina_evento'>
                <a className="button w-button" onClick={() => eliminaEvento({idEvento, meetingId})}><img src="/assets/media/trash-alt-solid.svg" alt="Icona elimina" /></a>
              </div>
              </>
                :
                ''
                }
                {isActive ?
                <a href={`evento${roomName+"/"+roomKey}`} className="button w-button" target="_blank">Accedi ora alla chiamata</a>
                : archivio ?
                <a href={`statistiche-evento/${idEvento}`} className="button w-button">Accedi alla statistiche</a>
                :
                ''
                }
              </div>
    )
};

EventoElement.propTypes = {
  auth: PropTypes.object.isRequired,
  eliminaEvento: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, { eliminaEvento })(EventoElement);